import { Feature } from "redux/services/config";

import { createLMFeatures } from "utils";

import { useQueryParams } from "./useQueryParams";

import ClusteredPinPlugin from "components/Map/plugins/clustered-pin-control";

interface Props {
  preloadedFeatures?: Feature[];
  clusteredPinControlInstance: React.MutableRefObject<ClusteredPinPlugin | null>;
}

export const useHandleFeatureRouteLoad = ({
  preloadedFeatures,
  clusteredPinControlInstance,
}: Props) => {
  const { routeFeatureId, queryParams } = useQueryParams();

  const handleFeatureRouteLoad = () => {
    // If the routeFeatureId is present in the URL, we need to display the route for the given feature
    if (routeFeatureId) {
      // Find feature within the features array
      const feature = preloadedFeatures?.find(
        (feature) => feature.properties.lm_id === routeFeatureId,
      );

      if (feature) {
        const lmFeature = createLMFeatures([feature]);
        clusteredPinControlInstance.current?.updateFeatureLabels(
          lmFeature,
          true,
        );
      } else console.warn(`Feature with ID ${routeFeatureId} not found`);

      // Remove the feature query param from the URL after the route has been loaded
      queryParams.delete("feature");
      const newUrl = `${new URL(window.location.href).pathname}?${queryParams.toString()}`;
      window.history.replaceState({}, "", newUrl);
    }
  };

  return {
    handleFeatureRouteLoad,
  };
};
